import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/Home.vue'
import PricePage from '../views/Price.vue'
import About from '../views/About.vue'
import Free from '../views/Free.vue'
import Tutorial from '../views/Tutorial/index.vue'
import Display from '../views/Display.vue'
import DesignerDetail from '../views/DesignerDetail.vue'
import Tools from '../views/Tools.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/price',
    name: 'Price',
    component: PricePage
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/free',
    name: 'Free',
    component: Free
  },
  {
    path: '/tutorial',
    component: Tutorial,
    children: [
      {
        path: '',
        component: () => import('../views/Tutorial/TutorialContent.vue'),
        props: { contentId: 'welcome' }
      },
      {
        path: 'skills',
        component: () => import('../views/Tutorial/content/basics/Skills.vue')
      },
      {
        path: 'space',
        component: () => import('../views/Tutorial/content/basics/Space.vue')
      },
      {
        path: 'level-up',
        component: () => import('../views/Tutorial/content/basics/LevelUp.vue')
      },
      {
        path: 'nobility',
        component: () => import('../views/Tutorial/content/basics/Nobility.vue')
      },
      {
        path: 'backpack',
        component: () => import('../views/Tutorial/content/basics/Backpack.vue')
      },
      {
        path: 'faq',
        component: () => import('../views/Tutorial/content/basics/FAQ.vue')
      },
      {
        path: 'ant-instance',
        component: () => import('../views/Tutorial/content/activities/AntInstance.vue')
      },
      {
        path: 'restaurant',
        component: () => import('../views/Tutorial/content/activities/Restaurant.vue')
      },
      {
        path: 'spring-festival',
        component: () => import('../views/Tutorial/content/activities/SpringFestival.vue')
      },
      {
        path: 'winter-resources',
        component: () => import('../views/Tutorial/content/activities/WinterResources.vue')
      },
      {
        path: 'lantern-festival',
        component: () => import('../views/Tutorial/content/activities/LanternFestival.vue')
      },
      {
        path: 'new-term',
        component: () => import('../views/Tutorial/content/activities/NewTerm.vue')
      },
      {
        path: 'valentines-day',
        component: () => import('../views/Tutorial/content/activities/ValentinesDay.vue')
      },
      {
        path: 'fantasy-forest',
        component: () => import('../views/Tutorial/content/activities/FantasyForest.vue')
      },
      {
        path: 'coffee-basic',
        component: () => import('../views/Tutorial/content/coffee/basic.vue')
      }
    ]
  },
  {
    path: '/display',
    name: 'Display',
    component: Display
  },
  {
    path: '/designer/:id',
    name: 'DesignerDetail',
    component: DesignerDetail
  },
  {
    path: '/tools',
    name: 'Tools',
    component: Tools
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
